import {getBuildTypeHref, getFavoriteBuildsHref, getProjectHref} from '../../../../../routes'
import type {ProjectsTreeItem} from '../../../../../types/projectTrees'

export const getBaseHref = (item: ProjectsTreeItem) => {
  switch (item.itemType) {
    case 'project':
      return getProjectHref(item.id, item.group === 'all')

    case 'buildType':
      return getBuildTypeHref(item.id, item.group === 'all')

    case 'link':
      return getFavoriteBuildsHref()

    default:
      return null
  }
}
